import React, {useContext, useMemo, useState} from "react";
import {Container, LightContainer, Loader, MaxBtn} from "../core/components/components";
import {MyModal} from "../core/components/modal";
import {TextareaInput} from "../core/input/basic";
import {DateInputUnix} from "../core/input/date";
import {maxiGetObj, maxiPostObj} from "../core/maxiosLeg";
import {UserContext} from "./UserContext";
import QualificationsMod from "./qualificationsMod";
import "./profile_style.sass"
import ReactImageFallback from "react-image-fallback";
import UploadTrainerPicture from "./profile_picture";
import {FormContextWrapper} from "../core/form_context";
import Status from "../core/status";
import {apiPost} from "../core/api";
import UserHistory from "./user_history";
import ViewCoursesOf from "../course/courses_of";

import {FaBars, FaTrashAlt} from "react-icons/fa";
import {Link} from "react-router-dom";
import {ReactSortable} from "react-sortablejs";
import {checkPermissions} from "../club/permissionsHelpers";

export default function Profile({match}) {
    const child_ID = match?.params?.child_ID ? parseInt(match?.params?.child_ID) : null;
    const [state, setState] = useState({});
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState(false);
    const context=useContext(UserContext)
    const user = context?.user || {}

    const load = () => !!child_ID && maxiGetObj({
        url: "/user/profile/" + child_ID,
        success: data => {
            setState(data)
            setLoading(false)
        }
    })
    useMemo(load, [])
    const editable = (user.trainer && child_ID === user.ID) || checkPermissions(context, "user");
    const trainer = state.user || {}
    const details = trainer.details || {};
    const image = trainer.image ? <ReactImageFallback
        src={`https://vereinfacht-public.s3-eu-west-1.amazonaws.com/profile_pictures/${trainer.verein_ID}/${trainer.image.indexOf("_mid.jpg") > -1 ? trainer.image : trainer.image.replace(".jpg", "_mid.jpg")}`} // "https://www.turnverein-st-valentin.at/timthumb/timthumb.php?src=/files/turnverein/team/" + t.image + "&w=600&h=640&a=t"
        fallbackImage="/static/img/team_fallback.jpg"
        initialImage="https://uid-suche.eu/src/img/ajax-loader-fff.gif"
        width
        alt={trainer.fullname}
    /> : <img src={"/static/img/team_fallback.jpg"}/>;

    return <Container name={"profil"} hideHeading>


        <div className={"trainersList"}>
            <div> {
                !!user && (user.role > 10 || (child_ID === user.ID && user.verein_ID !== 0)) ?
                    <UploadTrainerPicture child={{...trainer, ID: child_ID}} trigger={image}/> :
                    image
            }
            </div>
        </div>
        <LightContainer addName={<>{state.user?.fullname}</>} name={"details"} hideHeading>
            <Loader loading={loading}/>
            {
                editable && <div style={{float: "right"}}>
                    {
                        user.role > 10 && <>
                            <MyModal trigger={<MaxBtn>Veränderungen</MaxBtn>}>
                                <Container name={"Veränderungen"}>
                                    {child_ID && <UserHistory userID={child_ID} personType={"trainerDetails"}/>}
                                </Container>
                            </MyModal>&nbsp;
                            <Link to={"/benutzer/profil/" + child_ID}><MaxBtn>zum Benutzerkonto</MaxBtn></Link>
                        </>
                    }
                    <MaxBtn onClick={() => setViewMode(!viewMode)}>{viewMode ? "Bearbeiten" : "Anzeigen"}</MaxBtn>
                </div>
            }
            {editable && state.user && !viewMode && <ProfileEdit user={state.user} reload={load} trainer={{child_ID: state.user.ID, ...state.user.details}}/>}
            {
                (!editable || viewMode) && <>
                    {
                        details.trainerSince && <>
                            <b>Trainer im Verein seit</b> {details.trainerSince.split("-")[0]}<br/><br/>
                        </>
                    }
                    {
                        details.trainerBecause && <>
                            <b>Ich bin gerne Trainer{user.sex === "fem" && "in"}, weil ...</b>
                            <br/>
                            {details.trainerBecause.split("\n").map(a => [a, <br/>])}<br/><br/>
                        </>
                    }
                    {
                        details.iLike && <>
                            <b>Der Turnverein gefällt mir, weil ...</b>
                            <br/>
                            {details.iLike.split("\n").map(a => [a, <br/>])}<br/><br/>
                        </>
                    }


                </>
            }
        </LightContainer>


        {
            state.user &&
            <PrintQualitifactions
                state={state}
                setStateRaw={setState}
                editable={editable}
                reload={load}
                superUser={user.role > 80}
            />

        }
        {
            editable && <MyModal trigger={<MaxBtn>Aus- oder Weiterbildung hinzufügen</MaxBtn>}>

                {close => <QualificationsMod reload={load} qualification={{child_ID}} close={close}/>}

            </MyModal>
        }
        <LightContainer name={"Meine Angebote"}>
            {child_ID && <ViewCoursesOf id={child_ID}/>}
        </LightContainer>
    </Container>
}

class ProfileEdit extends React.Component {
    state = {
        trainer: this.props.trainer,
        user: this.props.user,
    }
    setState = this.setState.bind(this);
    apiPost = apiPost.bind(this);
    handleSubmit = e => {
        e.preventDefault();
        this.setState({loading: true})
        this.apiPost("/user/profile", this.state.trainer, resp => {
            this.setState({loading: false})
            this.props.reload && this.props.reload()
        })
    }
    static contextType = UserContext;

    render() {
        const {user, trainer, loading, error} = this.state;
        const {club,} = this.context;
        return <FormContextWrapper value={{state: this.state, setState: this.setState}} onSubmit={this.handleSubmit}>
            <Status type={"error"} text={error}/>
            <DateInputUnix name={"Trainer seit"} tag={"trainer_trainerSinceUnix"}/>
            <TextareaInput name={<>Ich bin gerne Trainer{user.sex === "fem" && "in"}, weil...</>} tag={"trainer_trainerBecause"}/>
            <TextareaInput name={`Der ${club.name.toLowerCase().includes("dance") ? "Tanzverein" : "Turnverein"} gefällt mir, weil ...`} tag={"trainer_iLike"}/>
            <MaxBtn>Speichern</MaxBtn>
            <Loader loading={loading}/>
        </FormContextWrapper>
    }
}

const now = new Date();

function PrintQualitifactions({state, setStateRaw, editable, reload, superUser}) {
    const setState = qs => {
        setStateRaw({...state, qualifications: qs})
        maxiPostObj({url: "/user/qualifications/order", data: qs.map((q, i) => [q.ID, i]), success: () => null})
    }

    const SortableOrNot = superUser ? ReactSortable : React.Fragment;
    return (state.qualifications?.length > 0 || editable) && <LightContainer name={"Meine Ausbildungen"}>
        <ul id={"qualifications_list"}>

            <SortableOrNot list={state.qualifications} setList={setState} swap>
                {
                    state?.qualifications?.map(qualification => (
                        <li key={qualification.ID} style={{opacity: qualification.showing ? "1" : "0.7"}}>
                            <h3 style={editable ? {} : {marginBottom: 0}}>
                                {
                                    editable ? <div className={"rightContainer"}>
                                            {qualification.start.split("-")[0]}
                                            &nbsp;-&nbsp;
                                            {
                                                qualification.end &&
                                                (qualification.start.split("-")[0] !== qualification.end.split("-")[0] && qualification.end.split("-")[0])
                                            }
                                            {
                                                (!qualification.end || (new Date(qualification.end) > now)) && " derzeit in Ausbildung"
                                            }
                                            {
                                                superUser && <><br/>
                                                    <br/>
                                                    <FaBars className={"moveHandle"}/>
                                                    <br/>
                                                    <MyModal trigger={<FaTrashAlt style={{margin: "10px"}}/>}>
                                                        {
                                                            close => <Container name={"Ausbildung löschen"}>
                                                                <MaxBtn onClick={() => {
                                                                    maxiPostObj({
                                                                        url: "/user/qualifications/delete", data: {ID: qualification.ID}, success: () => {
                                                                            reload()
                                                                            close()
                                                                        }
                                                                    })
                                                                }}>Löschen</MaxBtn>
                                                            </Container>
                                                        }
                                                    </MyModal>
                                                </>
                                            }
                                        </div> :
                                        <div className={"rightContainer"}>
                                            {
                                                (!qualification.end || (new Date(qualification.end) > now)) && " derzeit in Ausbildung"
                                            }
                                        </div>

                                }
                                {qualification.titleDisplay.label}
                            </h3>
                            {editable && <>{qualification.institute.label} ({qualification.location.label}) <br/></>}

                            {
                                editable && <MyModal trigger={<MaxBtn>Bearbeiten</MaxBtn>}>
                                    {close => <QualificationsMod qualification={qualification} reload={reload} close={close}/>}
                                </MyModal>}
                        </li>
                    )) || null
                }
            </SortableOrNot>
        </ul>
    </LightContainer>
}
